var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(`position:absolute;left:${!_vm.collapse?0:-_vm.width}px;top:43px;bottom:0;width:${_vm.width}px;background:none;transition:all 0.8s;`)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }